<div class="bl-page">

  <!-- =============================================
       HERO BANNER
       ============================================= -->
  <div class="bl-hero">
    <div class="bl-hero-inner">

      <!-- Left: Text -->
      <div class="bl-hero-content">
        <p class="bl-hero-eyebrow">Discover Sehyog Insights</p>
        <h1 class="bl-hero-title">
          Explore Our <span>Latest</span><br>Articles
        </h1>
        <p class="bl-hero-desc">
          Stay updated with the latest educational insights, success stories,
          and expert guidance to help students achieve their academic goals.
        </p>
        <button class="bl-hero-btn" (click)="scrollToBlogs()">
          Read Articles
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2.5"
               stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12h14M12 5l7 7-7 7"/>
          </svg>
        </button>

        <!-- Stats strip -->
        <div class="bl-hero-stats">
          <div class="bl-hero-stat">
            <span class="bl-hero-stat-num">{{ blogs.length }}+</span>
            <span class="bl-hero-stat-label">Articles</span>
          </div>
          <div class="bl-hero-stat">
            <span class="bl-hero-stat-num">11+</span>
            <span class="bl-hero-stat-label">Subjects covered</span>
          </div>
          <div class="bl-hero-stat">
            <span class="bl-hero-stat-num">Free</span>
            <span class="bl-hero-stat-label">Always free to read</span>
          </div>
        </div>
      </div>

      <!-- Right: Featured image -->
      <div class="bl-hero-image">
        <img
          [src]="featuredBlog?.image || '/assets/images/default-hero.jpg'"
          [alt]="featuredBlog?.title || 'Featured Blog'" />
      </div>

    </div>
  </div>

  <!-- =============================================
       BLOG GRID
       ============================================= -->
  <div class="bl-main" id="calendar-section">

    <!-- Section header -->
    <div class="bl-section-header">
      <div class="bl-section-header-left">
        <span class="bl-section-eyebrow">Fresh from Sehyog</span>
        <h2 class="bl-section-title">Latest <span>Articles</span></h2>
      </div>
    </div>

    <!-- Blogs -->
    <div *ngIf="blogs.length > 0; else noBlogs">
      <div class="bl-grid">
        <div
          *ngFor="let blog of blogs"
          class="bl-card"
          (click)="openBlog(blog)">

          <!-- Image -->
          <div class="bl-card-img-wrap">
            <img [src]="blog.image" [alt]="blog.title" />
            <span class="bl-card-category" *ngIf="blog.category">
              {{ blog.category }}
            </span>
          </div>

          <!-- Body -->
          <div class="bl-card-body">

            <!-- Meta -->
            <div class="bl-card-meta">
              <span class="bl-card-date">
                <svg width="13" height="13" viewBox="0 0 14 14" fill="none">
                  <path d="M11.667 2.333H2.333C1.597 2.333 1 2.93 1 3.667v9.333c0 .737.597 1.334 1.333 1.334h9.334c.736 0 1.333-.597 1.333-1.334V3.667c0-.737-.597-1.334-1.333-1.334zM11.667 13H2.333V5.667h9.334V13z" fill="currentColor"/>
                </svg>
                {{ blog.publishedDate | date: 'dd MMM yyyy' }}
              </span>
              <span class="bl-card-author" *ngIf="blog.author">
                {{ blog.author }}
              </span>
            </div>

            <!-- Title -->
            <h3 class="bl-card-title">{{ blog.title }}</h3>

            <!-- Snippet -->
            <p class="bl-card-snippet" *ngIf="blog.snippet">
              {{ blog.snippet }}
            </p>

            <!-- Read more -->
            <span class="bl-card-read">
              Read article
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                   stroke="currentColor" stroke-width="2.5"
                   stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </span>

          </div>
        </div>
      </div>
    </div>

    <!-- Empty state -->
    <ng-template #noBlogs>
      <div class="bl-empty">
        <div class="bl-empty-icon">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="1.5"
               stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
            <polyline points="10 9 9 9 8 9"/>
          </svg>
        </div>
        <h3 class="bl-empty-title">No articles yet</h3>
        <p class="bl-empty-text">Check back soon — new articles are published regularly.</p>
      </div>
    </ng-template>

  </div>

</div>